<template>
    <div class="search-error" v-show="hasError">
        <div class="mapsearch-error">
            <div class="error-list">
                <div class="message" v-if="isNoListings">
                    {{molang('search.filter.searchError')}}
                </div>
                 <div class="message" v-else-if="isLastPage">
                    See More Homes
                </div>
                <div class="adjust-filters">
                    <span class="title">{{molang('search.filter.adjustFilter')}}</span>
                </div>
                <ul class="actions">
                    <li>
                        <button type="button" class="link" @click.stop="resetFilter">{{molang('search.filter.resetFilter')}}</button>
                    </li>
                    <li>
                        <button type="button" class="link" @click="goToSearchNearBy">{{molang('search.filter.changeSearch')}}</button>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script src="./search-errorbox.js"></script>

<style lang="scss">
@use './search-errorbox.scss' as *;
</style>
